// The public code-preview component (title + copy/framework buttons +
// Prism-highlighted body). Renamed from `Code` — the bare `Code` name
// collided with `code`/`Code` keys produced from markdown and AI-generated
// content, which auto-extended this component's chrome by key. Bare `code`
// keys now render as plain elements.
export const CodePreviewWithTitle = {
  extends: 'CodeWithTitleAndButtons',
  flow: 'y',
  minWidth: 'H',
  maxWidth: '50%',
  '@tabletS': {
    width: 'max-content',
    widthRange: 'auto'
  }
}
